<template>
  <table>
    <colgroup>
      <col width="80px" />
      <col />
      <col />
      <col />
    </colgroup>
    <thead>
    <tr>
      <th>순번</th>
      <th>구분</th>
      <th>인원</th>
      <th>점유율</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(item, index) in dataList" :key="index">
      <td>{{ index + 1 }}</td>
      <td>{{ item.구분 }}</td>
      <td>{{ item.인원 }}</td>
      <td>{{ item.점유율 }}%</td>
    </tr>
    <tr>
      <th colspan="2">합계</th>
      <th>{{ total }}</th>
      <th>100%</th>
    </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "pageChartTable",
  props: {
    dataList: {
      type: Array,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #cdcdcd;
    padding: 6px 4px;
  }

  th,
  tr.avg td {
    font-size: 14px;
    font-weight: 500;
    text-align: center;

    background: #f9f9f9;
  }
  td {
    font-size: 14px;
    font-weight: 400;
    text-align: center;

    background: white;
  }
}
</style>
